import {priority} from '@priority-software/priority-proto-api/lib';
import {noDefaultMessageHandling} from '../../../../../services/form/form';

export const fetchMax = 100;
export const SETTINGS_KEY = 'specialFormsPanelSettings';

export const monitorPromoPretext = 'Prom_Panel';

export type SettingsPanelCol = {
    title: string;
    name: string;
    isDefault: boolean;
    isChecked: boolean;
};

export const defaultSidePanelOptions = {
    ...noDefaultMessageHandling,
    ...{withLoader: false, keepFocus: true}
};

export enum MonitoredActions {
    Open = 'Open',
    Toggle = 'OpenTab',
    Search = 'Search',
    Settings = 'Settings'
}

export enum MonitoredPromoActions {
    Show = 'Show',
    Close = 'Close'
}

export const subformTypeTitles = {
    [priority.netitems.form.SubformType.Attachments]: 'Attachments',
    [priority.netitems.form.SubformType.StatusLog]: 'HistoryStatus',
    [priority.netitems.form.SubformType.ChangeLog]: 'HistoryChanges'
};
